import format from "date-fns/format"
import camelCase from "lodash/camelCase"
import snakeCase from "lodash/snakeCase"
import i18n from "~/i18n"

export function listKeyToFileName(listKey) {
    let translationKey = ""

    switch (listKey) {
        case "supervisor-participants":
            translationKey = "supervisor.breadCrumb.participants"
            break

        case "supervisor-programs-all":
            translationKey = "supervisor.courseTabs.all.text"
            break
        case "supervisor-programs-participants":
            translationKey = "supervisor.courseTabs.participants.text"
            break
        case "supervisor-programs-catalog":
            translationKey = "supervisor.courseTabs.catalog.text"
            break

        /* Requests */
        case "supervisor-lms":
        case "supervisor-lms-historical":
            translationKey = "supervisor.breadCrumb.lms"
            break
        case "supervisor-external":
        case "supervisor-external-historical":
            translationKey = "supervisor.breadCrumb.external"
            break
        case "supervisor-experience":
        case "supervisor-experience-historical":
            translationKey = "supervisor.breadCrumb.experience"
            break
        case "supervisor-preregister":
        case "supervisor-preregister-historical":
            translationKey = "supervisor.breadCrumb.preregister"
            break

        case "monitoring-report":
            translationKey = "supervisor.monitoringReport"
            break

        default:
            throw new Error(
                `Invalid key ${listKey} to generate the translation key`
            )
    }

    return addDateAndExtentionToFileName({
        fileName: i18n.global.t(translationKey),
        extension: "csv",
    })
}

export function addDateAndExtentionToFileName({ fileName, extension }) {
    const date = format(new Date(), "yyyy-MM-dd")
    return `${snakeCase(fileName)}-${date}.${extension}`
}

export function urlForDownload(key) {
    const CALLS = /supervisor-calls-/.test(key) ? key : ""
    const USER_CALLS = /supervisor-user-calls-/.test(key) ? key : ""
    const HISTORIC_FORMATION = /supervisor-historical-formation/.test(key)
        ? key
        : ""
    switch (key) {
        /* Participants */
        case "supervisor-participants":
            return "/supervisor/participants/download"

        /* Programs */
        case "supervisor-programs-all":
            return "/supervisor/training/all/download"
        case "supervisor-programs-participants":
            return "/supervisor/training/participants/download"
        case "supervisor-programs-catalog":
            return "/supervisor/training/catalog/download"

        /* Calls */
        case CALLS: {
            // i.e. supervisor-calls-25
            const userId = CALLS.split("-").pop()
            return `/supervisor/participants/${userId}/calls/download`
        }
        case USER_CALLS: {
            // i.e. supervisor-user-calls-34
            const programId = USER_CALLS.split("-").pop()
            return `/supervisor/training/${programId}/calls/download`
        }

        case HISTORIC_FORMATION: {
            const userId = HISTORIC_FORMATION.split("-").pop()
            return `/supervisor/participants/${userId}/historicalFormation/download`
        }

        /* Requests */
        case "supervisor-lms":
            return "/supervisor/requests/lms/pending/download"
        case "supervisor-lms-historical":
            return "/supervisor/requests/lms/historic/download"
        case "supervisor-external":
            return "/supervisor/requests/external/pending/download"
        case "supervisor-external-historical":
            return "/supervisor/requests/external/historic/download"
        case "supervisor-experience":
            return "/supervisor/requests/experience/pending/download"
        case "supervisor-experience-historical":
            return "/supervisor/requests/experience/historic/download"
        case "supervisor-preregister":
            return "/supervisor/requests/preregister/pending/download"
        case "supervisor-preregister-historical":
            return "/supervisor/requests/preregister/historic/download"
        default:
            throw new Error(`Invalid key ${key} to generate base download url`)
    }
}

export function statusClass(status) {
    switch (status.toLowerCase()) {
        case "ok":
        case "approved":
        case "enrolled":
            return "text-success"
        case "ko":
        case "rejected":
        case "notenrolled":
        case "not-enrolled":
        case "denied":
            return "text-danger"
        default:
            return "text-gray-medium"
    }
}

export function statusIcon(status) {
    switch (status.toLowerCase()) {
        case "ok":
        case "approved":
            return "approved"
        case "ko":
        case "rejected":
        case "denied":
            return "failed"
        default:
            return "coursing"
    }
}

export function translatedStatus(status) {
    const key = camelCase(status)
    return i18n.global.t(`supervisor.requestStatus.${key}`)
}

export function adaptIntoSelectionObject(val) {
    if (typeof val === "number") {
        return {
            included: [val],
            excluded: [],
            filter: [],
            total: 1,
        }
    }
    const { included = [], excluded = [], filter = [], total = 0 } = val

    return { included, excluded, filter, total }
}

export function selectionIncludes(selection, id) {
    const {
        query: { included, excluded },
        selectAll,
    } = selection
    if (included.includes(id)) return true
    if (excluded.includes(id)) return false
    return selectAll
}

export function numSelectedItems(selection, instance) {
    const {
        query: { included, excluded },
        selectAll,
    } = selection

    if (excluded.length === 0 && included.length === 0) {
        return instance.totalCount
    } else if (selectAll) {
        return instance.totalCount - excluded.length
    } else {
        return included.length
    }
}
